import * as React from 'react'
import { QuestionEditorComponentProps } from 'jobs/questions/props'
import BreakerQuestionViewModel from '../../BreakerQuestionViewModel'

interface Props
  extends QuestionEditorComponentProps<BreakerQuestionViewModel> {}

export default function BreakerEditorInput(_: Props) {
  return <></>
}
